(function () {
  'use strict';
  if (window.rxConsentBridge) return;

  var loading = false;
  var applying = false;
  var pending = false;
  var scheduled = false;
  var loadAttempts = 0;
  var status = 'waiting';

  function log(label, data) {
    if (window.rxDebug && window.rxDebug.log) window.rxDebug.log('consent', label, data);
  }

  function choice() {
    var instance = window.CookieScript && window.CookieScript.instance;
    if (!instance || typeof instance.currentState !== 'function') return null;
    var state = instance.currentState();
    // An absent choice is not an acceptance or a rejection. Shopify's region
    // policy governs that visitor until an explicit (possibly saved) choice.
    if (!state || (state.action !== 'accept' && state.action !== 'reject')) return null;
    if (state.action === 'accept' && !Array.isArray(state.categories)) return null;
    var categories = state.categories || [];
    function allowed(category) {
      return state.action === 'accept' && categories.indexOf(category) !== -1;
    }
    return {
      analytics: allowed('performance'),
      marketing: allowed('targeting'),
      preferences: allowed('functionality'),
      sale_of_data: allowed('targeting')
    };
  }

  function api() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function matches(privacy, desired) {
    if (typeof privacy.currentVisitorConsent !== 'function') return false;
    var current = privacy.currentVisitorConsent();
    return Object.keys(desired).every(function (key) {
      return current[key] === (desired[key] ? 'yes' : 'no');
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    // CookieScript's native integration, when enabled, gets to update first.
    // The comparison below avoids a second write of an identical choice.
    window.setTimeout(function () { scheduled = false; sync(); }, 0);
  }

  function sync() {
    try {
      var desired = choice();
      if (applying) { pending = true; return; }
      var privacy = api();
      if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
        var shopify = window.Shopify;
        if (loading || !shopify || typeof shopify.loadFeatures !== 'function' || loadAttempts >= 3) return;
        loading = true;
        loadAttempts += 1;
        status = 'loading-api';
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          loading = false;
          if (error) { status = 'api-load-error'; log(status, {}); return; }
          schedule();
        });
        return;
      }
      if (!desired) { status = 'waiting-for-choice'; return; }
      if (matches(privacy, desired)) { status = 'synced'; return; }
      applying = true;
      pending = false;
      status = 'syncing';
      privacy.setTrackingConsent(desired, function (error) {
        applying = false;
        status = error && error.error ? 'consent-error' : 'synced';
        log(status, desired);
        if (pending) { pending = false; schedule(); }
      });
    } catch (error) {
      loading = false;
      applying = false;
      status = 'consent-error';
      log(status, { message: String(error.message || error).slice(0,160) });
    }
  }

  window.rxConsentBridge = {
    version: '1.0.0',
    state: function () {
      var privacy = api();
      return {
        status: status,
        cookieScriptChoice: choice(),
        shopifyConsent: privacy && privacy.currentVisitorConsent ? privacy.currentVisitorConsent() : null
      };
    }
  };
  ['CookieScriptLoaded', 'CookieScriptCurrentState', 'CookieScriptAccept', 'CookieScriptAcceptAll', 'CookieScriptReject'].forEach(function (name) {
    window.addEventListener(name, schedule);
  });
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  schedule();
})();
